var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgApple(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 78,
    height: 58,
    viewBox: "0 0 78 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    opacity: 0.203852,
    x: 1,
    y: 1,
    width: 76,
    height: 56,
    rx: 8,
    fill: "white",
    stroke: "#8392AB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.401 16C43.5427 17.299 43.0232 18.6045 42.2512 19.5423C41.4792 20.4807 40.2121 21.2096 38.9719 21.1133C38.8028 19.84 39.4293 18.5115 40.1446 17.6815C40.9427 16.7442 42.2883 16.0449 43.401 16ZM47.9954 32.2738C47.8629 32.22 45.0635 31.083 45.0331 27.7867C45.0085 25.0379 47.2228 23.687 47.4128 23.5711C47.4168 23.5686 47.4199 23.5667 47.4221 23.5654C46.1229 21.6569 44.0997 21.3948 43.3789 21.3646C42.3258 21.2575 41.3041 21.662 40.4698 21.9923C39.9401 22.202 39.4858 22.3818 39.1471 22.3818C38.7691 22.3818 38.3021 22.1959 37.7781 21.9873C37.092 21.7142 36.3082 21.4022 35.4986 21.4177C33.6215 21.4451 31.8921 22.5126 30.9244 24.1984C28.9764 27.5931 30.4272 32.6221 32.3255 35.3765C33.2545 36.7231 34.3618 38.2398 35.8159 38.1846C36.4666 38.1589 36.9292 37.9612 37.4075 37.7568C37.9591 37.521 38.5316 37.2763 39.4377 37.2763C40.3033 37.2763 40.8507 37.5139 41.377 37.7424C41.8797 37.9607 42.3631 38.1705 43.0861 38.1572C44.5925 38.1293 45.5488 36.7827 46.4702 35.4312C47.5016 33.9184 47.9464 32.4522 47.9963 32.2878C47.998 32.2823 47.9992 32.2783 48 32.2757C47.9994 32.2755 47.9979 32.2748 47.9954 32.2738Z",
    fill: "black"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgApple);
export default __webpack_public_path__ + "static/media/apple.ed630c3f0428f676872781cc452b20a6.svg";
export { ForwardRef as ReactComponent };